import React from 'react'
import { FaEdit } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';

export default function VenueListAction(props) {

    const { editModal, modalLoading, editForm } = props;

    const edit_venue = () => {
        modalLoading(true)
        editModal(true)
        editForm(props.data)
        modalLoading(false)
    }

    return (
        <div>
            <FaEdit size={20} className='edit ms-3'
                onClick={() => edit_venue()}
                data-tooltip-id="edit"
                data-tooltip-content="Edit Venue!"
                data-tooltip-place="bottom"
            />
            <Tooltip id="edit" style={{ backgroundColor: "rgb(71, 187, 76)", zIndex: '9', lineHeight: 'normal' }} />
        </div>
    )
}
